import { Trans, useLingui } from '@lingui/react/macro';
import { Switch } from '@repo/videa-components/src/ui/switch';

import {
  usePreferences,
  usePreferencesPracticeUpdate,
} from '@/react-query/usePreferences';

import { VideaTypography } from '../../../common-components/elements/VideaTypography/VideaTypography';

export const HDOffByDefault = () => {
  const preferences = usePreferences();
  const preferencesUpdate = usePreferencesPracticeUpdate();
  const isHQOffByDefault = preferences?.data?.hqOffByDefault;
  const { t } = useLingui();

  return (
    <>
      <Switch
        checked={!isHQOffByDefault}
        onCheckedChange={(checked) => {
          preferencesUpdate.mutate({
            hqOffByDefault: !checked,
          });
          preferencesUpdate.mutate({
            enableHqOnThumbnails: false,
          });
        }}
      />

      <VideaTypography className="pref-label" variant="labelSmall">
        <Trans>
          Image Quality (HD) default
          <span className="pref-helper">
            {isHQOffByDefault
              ? t`Radiographs displayed in normal quality by default`
              : t`Radiographs displayed in high quality by default`}
          </span>
        </Trans>
      </VideaTypography>
    </>
  );
};
